import { LazyModule } from 'owa-bundling';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyAction } from 'owa-bundling';
import SmartComposePlugin from './plugin/SmartComposePlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SmartComposePlugin" */ './plugin/SmartComposePlugin')
);

export type LazySmartComposePlugin = LazyPlugin<SmartComposePlugin>;

export let LazySmartComposePluginClass = createLazyPlugin(
    lazyModule,
    m => m.default,
    'SmartCompose',
    null
);

export let updateRecipientsForSmartCompose = new LazyAction(
    lazyModule,
    m => m.updateRecipientsForSmartCompose
);
